export const SubscriptionNotification = () => {
  return (
    <div className="widget-container">
      Interested in data on this tab? Subscribe to see more.
    </div>
  )
}